import React from 'react';
import { AREAS_ATENCION } from '../../constants/areasAtencion';
import '../../style/components/SelectorAreaAtencion.css';

// Grid de tarjetas-botón, una por área de atención, coloreadas según AREAS_ATENCION. Se
// reutiliza en el check-in de PanelDiario, el alta de cliente espontáneo (ModalCrearTurno)
// y la derivación de área desde AtencionPage.
function SelectorAreaAtencion({ valor, onChange, disabled = false }) {
    return (
        <div className="selector-area-atencion">
            {AREAS_ATENCION.map((area) => {
                const seleccionada = valor === area.valor;
                return (
                    <button
                        key={area.valor}
                        type="button"
                        className={`selector-area-atencion-item ${seleccionada ? 'selector-area-atencion-item-activo' : ''}`}
                        style={seleccionada
                            ? { backgroundColor: area.color, borderColor: area.color, color: '#fff' }
                            : { color: area.color, borderColor: `${area.color}40`, backgroundColor: area.bgColor }
                        }
                        onClick={() => onChange(area.valor)}
                        disabled={disabled}
                    >
                        <i className={`bi ${area.icono} selector-area-atencion-icono`}></i>
                        {area.etiqueta}
                    </button>
                );
            })}
        </div>
    );
}

export default SelectorAreaAtencion;
